import BaseModel from "lib/model";
import Item from "models/item";

export default BaseModel.extend({
    idAttribute: "id",
    url: function () {
        if (this.isNew()) {
            return `/api/v3.1/catalog/${this.collection ? this.collection.parent.id : this.catalogId}/entries`;
        }
        return `/api/v3.0/catalog/${this.collection ? this.collection.parent.id : this.catalogId}/entry/${this.id}`;
    },
    props: {
        id: "objectId",
        item_id: "objectId",
        type: {
            type: "string",
            values: ["item", "separator", "image"],
            default: "item",
            required: true,
        },
        label: "string",
        notes: "string",
        before: "objectId",
        options: "object",
        company: "string",
    },
    session: {
        catalogId: "string",
    },
    children: {
        item: Item,
    },
});
